import { API, handleApiError } from "./utils";

export const updateGuide = async (guideData) => {
    try {
        const { data } = await API.put(`/guide/update/`, guideData);
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};